import { DomainProperty } from 'domains/models';
import { isEmail } from 'infras/validator';

export default class Email extends DomainProperty {
  constructor(value: string | null) {
    super(value);
  }

  isValid() {
    super.beforeValidate();

    const p = 'email';

    if (this.value) {
      if (!isEmail(this.value)) {
        this.addError(p, 'model.User.email.E002');
      }
    } else {
      this.addError(p, 'model.User.email.E001');
    }
    return super.isValid();
  }
}
